import { create } from "zustand";

type RunAddressVerificationGate = () => Promise<boolean>;

interface AddressVerificationGateState {
  runGate?: RunAddressVerificationGate;
  registerRunGate: (runGate?: RunAddressVerificationGate) => void;
}

// Bridges Signers' address-verification Save gate (address-standardization-
// spec.md §3/§7) up to ReviewPage's confirmAndSave, which lives outside the
// Signers form tree and has no direct access to its RHF instance — same
// bridge pattern as incomeChangeStore. Signers registers the live gate
// function (which owns the per-slot sequencing and opens
// AddressVerificationModal as needed) on mount; ReviewPage calls it via
// `runAddressVerificationGate` before it will let Save proceed.
export const useAddressVerificationGateStore = create<AddressVerificationGateState>((set) => ({
  runGate: undefined,
  registerRunGate: (runGate) => set({ runGate }),
}));

/**
 * Runs the registered address-verification gate, resolving `true` to let Save
 * proceed or `false` to abort it. Resolves `true` when no Signers section has
 * registered a gate (e.g. Save clicked before it mounts) — Save must never
 * hang on a gate that doesn't exist.
 * @returns {Promise<boolean>} Whether Save should proceed.
 */
export async function runAddressVerificationGate(): Promise<boolean> {
  const { runGate } = useAddressVerificationGateStore.getState();
  return runGate ? runGate() : true;
}
